import Load from './load';
import MapConfig from './map';

export default {
  Load,
  MapConfig,
};
